export interface ComicCategory {
  id: string;
  name: string;
  slug: string;
  description: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  description: string;
  status: string;
  latestChapter: string;
  updateDate: string;
  rating: number;
  views: number;
  tags: string[];
  chapters: ComicChapter[];
}

export interface ComicChapter {
  number: number;
  title: string;
  updateDate: string;
}

export const categories: ComicCategory[] = [
  { id: 'cat-1', name: '恋爱言情', slug: 'romance', description: '浪漫甜蜜的韩国恋爱漫画，感人至深的爱情故事，让你感受心动的每一刻。' },
  { id: 'cat-2', name: '奇幻冒险', slug: 'fantasy', description: '宏大世界观设定，精彩纷呈的奇幻冒险之旅，带你进入不可思议的异世界。' },
  { id: 'cat-3', name: '热血动作', slug: 'action', description: '燃爆全场的战斗场面，精彩绝伦的动作分镜，热血沸腾的韩漫体验。' },
  { id: 'cat-4', name: '都市生活', slug: 'urban', description: '贴近现实的都市题材，职场、校园、日常生活的细腻刻画，引发强烈共鸣。' },
  { id: 'cat-5', name: '悬疑惊悚', slug: 'thriller', description: '扣人心弦的悬疑情节，出人意料的剧情反转，让你欲罢不能的烧脑体验。' },
  { id: 'cat-6', name: '搞笑日常', slug: 'comedy', description: '轻松幽默的搞笑韩漫，欢乐解压的日常趣事，带给你一天好心情。' },
];

export const featuredComics: Comic[] = [
  {
    id: 'comic-1',
    title: '星光下的约定',
    author: '金智媛',
    category: '恋爱言情',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20webtoon%20romance%20cover%20art%2C%20young%20couple%20under%20starry%20night%20sky%2C%20soft%20pastel%20colors%2C%20romantic%20atmosphere%2C%20watercolor%20style%20illustration%2C%20gentle%20lighting%2C%20clean%20simple%20background%2C%20anime%20inspired%20character%20design%2C%20emotional%20and%20tender%20mood&width=800&height=1067&seq=comic-cover-01&orientation=portrait',
    description: '在繁华的首尔街头，两个陌生人的命运悄然交织。一段跨越十年的约定，在星光璀璨的夜晚重新点燃。',
    status: '连载中',
    latestChapter: '第128话',
    updateDate: '2026-07-02',
    rating: 9.6,
    views: 1280000,
    tags: ['恋爱', '都市', '治愈'],
    chapters: [
      { number: 128, title: '重逢的夜晚', updateDate: '2026-07-02' },
      { number: 127, title: '无法言说的心意', updateDate: '2026-06-29' },
      { number: 126, title: '雨中的告白', updateDate: '2026-06-26' },
    ],
  },
  {
    id: 'comic-2',
    title: '异世界剑圣',
    author: '朴正宇',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20Korean%20webtoon%20fantasy%20cover%20art%2C%20warrior%20with%20glowing%20sword%20in%20magical%20realm%2C%20dramatic%20lighting%2C%20dark%20and%20moody%20background%20with%20sparks%2C%20anime%20style%20illustration%2C%20powerful%20pose%2C%20detailed%20armor%20design%2C%20cinematic%20composition&width=800&height=1067&seq=comic-cover-02&orientation=portrait',
    description: '普通高中生林宇意外穿越到剑与魔法的世界，凭借惊人的天赋成为史上最年轻的剑圣。',
    status: '连载中',
    latestChapter: '第95话',
    updateDate: '2026-07-01',
    rating: 9.4,
    views: 980000,
    tags: ['奇幻', '冒险', '战斗'],
    chapters: [
      { number: 95, title: '最终决战', updateDate: '2026-07-01' },
      { number: 94, title: '觉醒的力量', updateDate: '2026-06-28' },
      { number: 93, title: '王都陷落', updateDate: '2026-06-25' },
    ],
  },
  {
    id: 'comic-3',
    title: '暗夜追踪者',
    author: '李承勋',
    category: '悬疑惊悚',
    categorySlug: 'thriller',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20Korean%20webtoon%20thriller%20cover%20art%2C%20detective%20in%20trench%20coat%20standing%20in%20rainy%20alley%20at%20night%2C%20neon%20light%20reflections%2C%20mysterious%20atmosphere%2C%20noir%20style%20illustration%2C%20dramatic%20shadows%2C%20cinematic%20lighting%2C%20suspenseful%20mood&width=800&height=1067&seq=comic-cover-03&orientation=portrait',
    description: '首尔连环失踪案背后的惊天秘密，一位退役刑警踏上危险的真相追踪之路。',
    status: '已完结',
    latestChapter: '第86话（完结）',
    updateDate: '2026-06-15',
    rating: 9.7,
    views: 1560000,
    tags: ['悬疑', '推理', '犯罪'],
    chapters: [
      { number: 86, title: '真相大白（完结）', updateDate: '2026-06-15' },
      { number: 85, title: '最后的线索', updateDate: '2026-06-12' },
      { number: 84, title: '幕后黑手', updateDate: '2026-06-09' },
    ],
  },
];

export const latestComics: Comic[] = [
  {
    id: 'comic-4',
    title: '办公室罗曼史',
    author: '崔恩珠',
    category: '都市生活',
    categorySlug: 'urban',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20office%20romance%20cover%20art%2C%20stylish%20office%20workers%20in%20modern%20building%2C%20warm%20lighting%2C%20professional%20yet%20romantic%20atmosphere%2C%20clean%20illustration%20style%2C%20soft%20colors%2C%20chic%20character%20design&width=800&height=1067&seq=comic-cover-04&orientation=portrait',
    description: '顶尖广告公司的冷面上司与新入职的热血菜鸟，在工作与爱情之间展开的甜蜜拉锯战。',
    status: '连载中',
    latestChapter: '第42话',
    updateDate: '2026-07-03',
    rating: 9.2,
    views: 650000,
    tags: ['职场', '恋爱', '喜剧'],
    chapters: [
      { number: 42, title: '意外的告白', updateDate: '2026-07-03' },
      { number: 41, title: '加班之夜', updateDate: '2026-06-30' },
      { number: 40, title: '竞标风云', updateDate: '2026-06-27' },
    ],
  },
  {
    id: 'comic-5',
    title: '神之塔：重生',
    author: '韩世贤',
    category: '奇幻冒险',
    categorySlug: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20Korean%20webtoon%20tower%20fantasy%20cover%20art%2C%20mysterious%20tower%20reaching%20into%20clouds%2C%20adventurers%20climbing%2C%20magical%20energy%20surrounding%2C%20grand%20scale%2C%20dramatic%20composition%2C%20rich%20colors%2C%20fantasy%20illustration%20style&width=800&height=1067&seq=comic-cover-05&orientation=portrait',
    description: '传说中登顶神之塔即可实现任何愿望。少年姜赫踏上攀登之塔的壮绝旅程，每层都是全新的世界。',
    status: '连载中',
    latestChapter: '第210话',
    updateDate: '2026-07-02',
    rating: 9.8,
    views: 3200000,
    tags: ['奇幻', '冒险', '战斗'],
    chapters: [
      { number: 210, title: '第50层的试炼', updateDate: '2026-07-02' },
      { number: 209, title: '新的同伴', updateDate: '2026-06-29' },
      { number: 208, title: '守护者的秘密', updateDate: '2026-06-26' },
    ],
  },
  {
    id: 'comic-6',
    title: '社长大人是猫',
    author: '尹美娜',
    category: '搞笑日常',
    categorySlug: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20webtoon%20comedy%20cover%20art%2C%20cat%20with%20business%20suit%20in%20office%20setting%2C%20funny%20and%20adorable%20illustration%2C%20bright%20and%20cheerful%20colors%2C%20cartoon%20style%2C%20playful%20atmosphere%2C%20clean%20simple%20background&width=800&height=1067&seq=comic-cover-06&orientation=portrait',
    description: '某天醒来，公司社长竟然变成了一只猫？！全公司上下鸡飞狗跳的爆笑日常就此展开。',
    status: '连载中',
    latestChapter: '第67话',
    updateDate: '2026-07-01',
    rating: 9.3,
    views: 780000,
    tags: ['搞笑', '日常', '萌宠'],
    chapters: [
      { number: 67, title: '猫社长的会议', updateDate: '2026-07-01' },
      { number: 66, title: '鱼罐头风波', updateDate: '2026-06-28' },
      { number: 65, title: '客户来访日', updateDate: '2026-06-25' },
    ],
  },
  {
    id: 'comic-7',
    title: '格斗天王',
    author: '郑泰浩',
    category: '热血动作',
    categorySlug: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Intense%20Korean%20webtoon%20fighting%20cover%20art%2C%20martial%20artist%20in%20dynamic%20action%20pose%2C%20dramatic%20impact%20effects%2C%20sweat%20and%20motion%2C%20dark%20arena%20background%2C%20powerful%20energy%2C%20bold%20colors%2C%20shounen%20style%20illustration&width=800&height=1067&seq=comic-cover-07&orientation=portrait',
    description: '地下格斗场的传奇拳手，为了寻找失踪的妹妹重返擂台，每一步都充满血与泪。',
    status: '连载中',
    latestChapter: '第156话',
    updateDate: '2026-07-02',
    rating: 9.5,
    views: 1450000,
    tags: ['格斗', '热血', '动作'],
    chapters: [
      { number: 156, title: '宿命的对决', updateDate: '2026-07-02' },
      { number: 155, title: '极限突破', updateDate: '2026-06-29' },
      { number: 154, title: '地下拳王', updateDate: '2026-06-26' },
    ],
  },
  {
    id: 'comic-8',
    title: '夏日奇迹',
    author: '安素英',
    category: '恋爱言情',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20webtoon%20summer%20romance%20cover%20art%2C%20young%20couple%20at%20beach%20sunset%2C%20warm%20golden%20hour%20lighting%2C%20gentle%20waves%2C%20romantic%20atmosphere%2C%20soft%20pastel%20colors%2C%20watercolor%20style%2C%20emotional%20and%20sweet%20mood&width=800&height=1067&seq=comic-cover-08&orientation=portrait',
    description: '济州岛的夏天，失意的画家遇见了神秘的冲浪少女。一段治愈而温暖的夏日恋曲。',
    status: '已完结',
    latestChapter: '第52话（完结）',
    updateDate: '2026-05-20',
    rating: 9.1,
    views: 520000,
    tags: ['恋爱', '治愈', '旅行'],
    chapters: [
      { number: 52, title: '永远的夏天（完结）', updateDate: '2026-05-20' },
      { number: 51, title: '离别与约定', updateDate: '2026-05-17' },
      { number: 50, title: '画中的你', updateDate: '2026-05-14' },
    ],
  },
];

export const faqItems = [
  {
    question: '韩国漫画网上的漫画都是免费的吗？',
    answer: '是的！我们平台上的所有韩国漫画均免费提供在线阅读。用户无需付费即可浏览海量韩漫资源，包括恋爱、奇幻、动作、悬疑等多种类型的漫画作品。我们致力于为广大漫画爱好者提供一个优质的免费韩漫阅读平台。',
  },
  {
    question: '网站多久更新一次漫画内容？',
    answer: '我们的漫画内容每日更新，热门连载作品通常每周更新1-3话。编辑团队会及时跟进韩国漫画的最新章节，确保用户可以第一时间阅读到最新的漫画内容。建议您收藏本站或关注更新列表，不错过任何精彩更新。',
  },
  {
    question: '手机上可以观看韩国漫画吗？',
    answer: '当然可以！韩国漫画网完美适配手机、平板和电脑等多种设备。您可以通过手机浏览器直接访问我们的漫画网址，享受流畅的移动端韩漫在线阅读体验。无论是通勤路上还是休闲时间，随时随地畅享韩漫乐趣。',
  },
  {
    question: '如何找到我想看的韩国漫画？',
    answer: '您可以通过多种方式找到喜欢的漫画：1）使用顶部的搜索功能直接搜索漫画名称；2）通过分类浏览（恋爱言情、奇幻冒险、热血动作等）；3）查看首页的热门推荐和新作速递板块；4）浏览作者专区。我们的推荐系统也会根据热门程度为您精选优质韩漫。',
  },
  {
    question: '网站上的漫画画质如何？',
    answer: '我们非常重视阅读体验，所有漫画均提供高清画质。平台支持自适应图片加载，根据您的网络状况和设备屏幕自动匹配最佳分辨率，确保流畅清晰的阅读效果。每一页漫画都经过精心优化，色彩还原度高，细节呈现完整。',
  },
];

export const brandAdvantages = [
  {
    title: '海量韩漫资源',
    description: '收录超过5000部韩国漫画作品，覆盖恋爱、奇幻、动作、悬疑、搞笑等多种题材，满足不同读者的阅读偏好。每日持续扩充漫画库，确保资源丰富多样。',
  },
  {
    title: '每日准时更新',
    description: '编辑团队7×24小时追踪韩漫更新动态，热门连载作品同步韩国最新进度，让国内读者无需漫长等待即可阅读最新章节。',
  },
  {
    title: '高清流畅阅读',
    description: '采用先进图片压缩与加速技术，所有漫画高清呈现。智能预加载功能确保翻页零延迟，提供沉浸式阅读体验。',
  },
];

export const testimonials = [
  {
    quote: '韩国漫画网是目前国内韩漫资源最全的平台之一，更新速度快、画质清晰，用户体验做得非常出色。对于韩漫爱好者来说，这是一个不可或缺的漫画网址。',
    author: '动漫周刊编辑部',
    role: '媒体推荐',
  },
  {
    quote: '在这里找到了很多在别处找不到的冷门韩漫佳作。分类清晰，搜索方便，手机阅读体验也很棒。已经成为我每天必刷的漫画网站了。',
    author: '资深韩漫读者 - 小雨',
    role: '用户评价',
  },
];